/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Linux_4Inputs */

const en_pc_dl_linux_4 = /** @type {(inputs: Pc_Dl_Linux_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flatpak: flatpak install --user ./pdfcraft-*.flatpak`)
};

const zh_pc_dl_linux_4 = /** @type {(inputs: Pc_Dl_Linux_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flatpak：flatpak install --user ./pdfcraft-*.flatpak`)
};

/**
* | output |
* | --- |
* | "Flatpak: flatpak install --user ./pdfcraft-*.flatpak" |
*
* @param {Pc_Dl_Linux_4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_linux_4 = /** @type {((inputs?: Pc_Dl_Linux_4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Linux_4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_linux_4(inputs)
	return zh_pc_dl_linux_4(inputs)
});
export { pc_dl_linux_4 as "pc.dl.linux.4" }